import { isAuthor } from "../../../../../clientlibs/weddingSite/js/utils";

const bwdSlide = {
  props: {
    dynamicClass: ".bwd-slide-dl-id.dynamicLoading",
  },

  init: function () {
    if (isAuthor()) {
      bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-bwdSlideAuthor.css", this.props.dynamicClass, false, true);
    }

    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-bwdSlide.css", this.props.dynamicClass, false, true);
  },
};

export default bwdSlide;
